import { toast } from 'react-toastify'
import { FileUpload } from 'components/FileUpload'
import { useTranslation } from 'react-i18next'
import axiosInstance from 'store/axiosInstance'

interface Props {
  id: string
  onSuccess?: () => void
}

export function UploadExcelTemplate({ id, onSuccess }: Props) {
  const { t } = useTranslation()

  return (
    <FileUpload
      text={t('add-sheet')}
      sendToApi={false}
      handleAsRawFile={async (file) => {
        const formData = new FormData()
        formData.append('files', file)
        axiosInstance
          .post(`/procurement-plans/${id}/items/upload-template`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(() => {
            onSuccess?.()
          })
          .catch(() => {
            toast('operation-failed')
          })
      }}
    />
  )
}
